import React from 'react';
import { useWidgetsQuery } from '../../../../api/useWidgetsQuery';
import { TabSlug } from '../../../../types';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Loading } from '../../../../../CommonComponents/OPL/Loading/Loading';
import { DesktopWidgetsEmpty } from '../../../../components/DesktopWidgets/DesktopWidgets.empty';
import { ErrorState } from '../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { WidgetContent } from '../../../../components/DesktopWidgets/components/WidgetContent/WidgetContent';

interface Props {
  tab: TabSlug;
}

export const GainLossMobile = ({ tab }: Props) => {
  const { isLoading, isError, refetch, data } = useWidgetsQuery({
    tab,
  });

  if (isLoading) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" mt={100}>
        <Loading />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" mt={100}>
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  if (data.included.length === 0) {
    return <DesktopWidgetsEmpty tab={tab} widgets={data} isFirmLevelUser={false} />;
  }

  return (
    <>
      <Box display="flex" flexDirection="column">
        {data.included.map(({ id, title }) => (
          <Box key={id} flex={1}>
            <WidgetContent id={id} title={title} />
          </Box>
        ))}
      </Box>
    </>
  );
};
